import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../app/guards'

/** Cost entries: who records them, or who reads project money. */
export const Route = createFileRoute('/_app/projects/cost-entries')({
  staticData: { crumb: 'projectCostEntries' },
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.cost_entries', 'projects.financials'),
  component: Outlet,
})
